var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Summary-Automata-icon@2x-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.98 18.5405H14.5V23.0205H18.98V18.5405ZM15.5 22.0205V19.5405H17.98V22.0205H15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9805 20.2798H20.9805V21.2798H33.9805V20.2798Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.98 24.02H14.5V28.5H18.98V24.02ZM15.5 27.5V25.02H17.98V27.5H15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9805 25.7602H20.9805V26.7602H33.9805V25.7602Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.5005H33.98V31.5005H14.5V30.5005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.98 34.8598H14.5V35.8598H33.98V34.8598Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.44 9H20.56C20.2507 9 20 9.25072 20 9.56V11.5H10.56C10.2507 11.5 10 11.7507 10 12.06V42.94C10 43.2493 10.2507 43.5 10.56 43.5H37.44C37.7493 43.5 38 43.2493 38 42.94V12.06C38 11.7507 37.7493 11.5 37.44 11.5H28V9.56C28 9.25072 27.7493 9 27.44 9ZM21.5 13.5V10.5H26.5V13.5H21.5ZM28 13V14.44C28 14.7493 27.7493 15 27.44 15H20.56C20.2507 15 20 14.7493 20 14.44V13H11.5V42H36.5V13H28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryIcon);
export default __webpack_public_path__ + "static/media/summary-icon.fadbb5b48283c048f89aa61400b2f912.svg";
export { ForwardRef as ReactComponent };